



import { FetchPrivateFileObjectUrl, IsPrivateFileUrl } from "@/helper/uploadHelper";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class PrivateImage extends Vue {
  @Prop({ type: String, default: "" })
  readonly src!: string;
  private resolvedSrc = "";
  private loadToken = 0;

  @Watch("src", { immediate: true })
  onSrcChanged() {
    this.LoadSrc();
  }

  beforeDestroy() {
    this.loadToken += 1;
    this.ReleaseResolved();
  }

  private ReleaseResolved() {
    this.Release(this.resolvedSrc);
    this.resolvedSrc = "";
  }

  private Release(objectUrl: string) {
    if (objectUrl && objectUrl.startsWith("blob:")) {
      URL.revokeObjectURL(objectUrl);
    }
  }

  private async LoadSrc() {
    this.loadToken += 1;
    const token = this.loadToken;
    if (!this.src) {
      this.ReleaseResolved();
      return;
    }
    if (!IsPrivateFileUrl(this.src)) {
      this.ReleaseResolved();
      this.resolvedSrc = this.src;
      return;
    }
    try {
      const objectUrl = await FetchPrivateFileObjectUrl(this.src);
      if (token !== this.loadToken) {
        this.Release(objectUrl);
        return;
      }
      this.ReleaseResolved();
      this.resolvedSrc = objectUrl;
    } catch (error) {
      if (token === this.loadToken) {
        this.ReleaseResolved();
        this.$emit("error", error);
      }
    }
  }
}
